<!-- 讨论列表 -->
<template>
  <!-- 讨论 区 -->
  <div class="mentee-zoom-dicuss">
    <div>
      <div class="mentee-zoom-dicuss-con">
        <zlr-discuss title="Other Information">
          <template v-if="commentList.length>0">
            <zlr-discuss-item v-for="(item, index) in commentList"
                              :key="index"
                              :avatar="item.avaurl"
                              :name="item.createRole === 'MENTEE'? item.menteeName:item.mentorName"
                              :time="item.createTime"
                              :content="item.content"></zlr-discuss-item>
          </template>
          <zlr-empty v-else></zlr-empty>
        </zlr-discuss>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getCommentsPage } from '@/api/comments'
// components
import discuss from '_c/discuss'
import ZlrEmpty from '_c/empty/empty'
export default {
  name: '',
  props: ['data'],
  components: {
    ZlrDiscuss: discuss.ZlrDiscuss,
    ZlrDiscussItem: discuss.ZlrDiscussItem,
    ZlrEmpty
  },
  data () {
    return {
      commentList: []
    }
  },
  computed: {},
  mounted () {
    this.getCommentsPage()
  },
  methods: {
    getCommentsPage () {
      if (!this.data.billId) return false
      getCommentsPage({ ...this.data }).then(res => {
        this.commentList = res.data.page.result
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
